import React from 'react';
import './style.scss';
export const Label = ({ requireInput, children }) => (
  <label className="sri-label">
    {children}
    {!!requireInput && <span>*</span>}
  </label>
);
